import React, { useEffect, useState } from 'react';
import './Privacypolicy.css';

const PrivacyPolicy = () => {
  const [isVisible, setIsVisible] = useState(false);
  const today = new Date();
  const lastUpdated = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`privacy-policy-container ${isVisible ? 'visible' : ''}`}>
      <div className="privacy-policy-content">
        <header className="privacy-header">
          <div className="header-decoration"></div>
          <h1>Privacy Policy</h1>
          <p className="effective-date">Effective Date: September 25, 2025</p>
          <p className="last-updated">Last Updated: September 25, 2025</p>
          <p className="disclaimer">
            At Harmon Property ("we," "our," or "us"), we respect your privacy. This Privacy Policy 
            explains how we collect, use, and protect information when you visit harmon.property (the "Site").
          </p>
        </header>

        <div className="privacy-content">
          {/* 1. Information We Collect */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">1</div>
              <h2>Information We Collect</h2>
            </div>
            <div className="section-content">
              <ul className="policy-list">
                <li>
                  <strong>Personal Information:</strong> If you voluntarily provide it (such as through 
                  contact forms or email).
                </li>
                <li>
                  <strong>Usage Data:</strong> Basic analytics information such as IP address, browser type, 
                  and pages visited.
                </li>
              </ul>
            </div>
          </section>

          {/* 2. How We Use Information */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">2</div>
              <h2>How We Use Information</h2>
            </div>
            <div className="section-content">
              <p>We use information to:</p>
              <ul className="policy-list">
                <li>Provide and improve the Site</li>
                <li>Respond to inquiries</li>
                <li>Ensure security and prevent abuse</li>
              </ul>
              <p>We do not sell or rent your personal information to third parties.</p>
            </div>
          </section>

          {/* 3. Cookies */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">3</div>
              <h2>Cookies</h2>
            </div>
            <div className="section-content">
              <p>
                The Site may use cookies or similar technologies to improve functionality and user experience. 
                You can disable cookies in your browser settings.
              </p>
            </div>
          </section>

          {/* 4. Data Security */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">4</div>
              <h2>Data Security</h2>
            </div>
            <div className="section-content">
              <p>
                We take reasonable measures to protect your information, but no method of transmission 
                over the internet is 100% secure.
              </p>
            </div>
          </section>

          {/* 5. Third-Party Services */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">5</div>
              <h2>Third-Party Services</h2>
            </div>
            <div className="section-content">
              <p>
                We may use third-party analytics or hosting providers. These providers have their own 
                privacy policies.
              </p>
            </div>
          </section>

          {/* 6. Your Rights */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">6</div>
              <h2>Your Rights</h2>
            </div>
            <div className="section-content">
              <p>
                Depending on your location, you may have rights to access, correct, or delete your 
                personal data. To make a request, contact us at{' '}
                <a href="mailto:info@harmon.property">info@harmon.property</a>.
              </p>
            </div>
          </section>

          {/* 7. Changes to This Policy */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">7</div>
              <h2>Changes to This Policy</h2>
            </div>
            <div className="section-content">
              <p>
                We may update this Privacy Policy from time to time. Changes will be posted on this 
                page with a new "Last Updated" date.
              </p>
            </div>
          </section>

          {/* 8. Contact */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">8</div>
              <h2>Contact</h2>
            </div>
            <div className="section-content">
              <p>
                For questions about this Privacy Policy or to report abuse, contact us at:
                <br />
                <a href="mailto:info@harmon.property">info@harmon.property</a>
              </p>
            </div>
          </section>
        </div>

        <footer className="privacy-footer">
          <p>© {today.getFullYear()} Harmon Property. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;